interface TransformedCategory {
  text: string;
  depth1?: any;
  depth2?: any;
  depth3?: any;
}

export function fnTransformCategory(
  category?: any,
  delimiter: string = '>',
): TransformedCategory | undefined {
  if (!category) return;

  const depths: any[] = [];
  let currentCategory = category;

  // Traverse up the hierarchy
  while (currentCategory) {
    depths.push(currentCategory);
    currentCategory = currentCategory.parent;
  }

  // Reverse to get the correct order from top to bottom
  depths.reverse();

  const result: TransformedCategory = {
    text: depths.map((cat) => cat.name).join(` ${delimiter} `),
  };

  // Assign depth properties based on the length of depths
  if (depths.length > 0) result.depth1 = depths[0];
  if (depths.length > 1) result.depth2 = depths[1];
  if (depths.length > 2) result.depth3 = depths[2];

  return result;
}
